export const baseURL = "https://admin.vidora.one/";
export const secretKey = "VA6k3gPW1q9kGscCSMJeYEYKAKx4eepm";
export const projectName = "Vidora";
export const folderStructurePath = "Vidora";
